import { Injectable, NgZone, inject } from '@angular/core'
import { Subject } from 'rxjs'
import { environment } from 'src/environments/environment'

const MESSAGE_TYPE = 'octa-google-calendar-oauth'

@Injectable({ providedIn: 'root' })
export class GoogleCalendarOAuthPopupService {
  private ngZone: NgZone = inject(NgZone)
  private readonly resultSubject = new Subject<'success' | 'error'>()
  readonly result$ = this.resultSubject.asObservable()
  private listenerAttached = false

  public init(): void {
    if (this.listenerAttached || typeof window === 'undefined') return
    const allowedOrigin = this.resolveOrigin(environment.borealURL)
    if (!allowedOrigin) return
    this.listenerAttached = true
    window.addEventListener('message', (event: MessageEvent) => {
      if (event.origin !== allowedOrigin) return
      const data = event.data
      if (!data || data.type !== MESSAGE_TYPE) return
      this.ngZone.run(() => this.resultSubject.next(data.result === 'success' ? 'success' : 'error'))
    })
  }

  private resolveOrigin(url: string): string {
    try {
      return new URL(url).origin
    } catch {
      return ''
    }
  }
}
